"use strict";var r=require("./Util/stringPad.cjs");exports.stringPadStart=function(t,i,s){return void 0===s&&(s=" "),r.stringPad(t,i,s)+t};
//# sourceMappingURL=stringPadStart.cjs.map
